export const FORM = "FORM";

export const DRAFT_QUOTE_DETAILS_REQUEST = "DRAFT_QUOTE_DETAILS_REQUEST";
export const DRAFT_QUOTE_DETAILS_FAILURE = "DRAFT_QUOTE_DETAILS_FAILURE";
export const DRAFT_QUOTE_DETAILS_SUCCESS = "DRAFT_QUOTE_DETAILS_SUCCESS";
export const DRAFT_QUOTE_DETAILS_RESET = "DRAFT_QUOTE_DETAILS_RESET";

export const CLEAR = "CLEAR";
